import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try { await api.post("/auth/forgot-password", { email }); setSent(true); }
        catch { setSent(true); }
        finally { setBusy(false); }
    };

    return (
        <div className="max-w-md mx-auto px-6 py-16" data-testid="forgot-page">
            <div className="text-[#ff4500] text-xs uppercase tracking-[0.3em] mb-2">Account</div>
            <h1 className="font-display text-5xl tracking-wide">Reset password</h1>
            {sent ? (
                <div className="mt-8 border border-[#22c55e]/40 bg-[#22c55e]/10 p-6" data-testid="forgot-sent">
                    <p className="text-sm text-[#cfcfcf]">If <span className="text-white">{email}</span> is registered, a reset link is on its way. Check your inbox (and spam).</p>
                    <Link to="/login" className="inline-block mt-4 text-xs uppercase tracking-[0.2em] text-[#ff4500] hover:underline">Back to log in</Link>
                </div>
            ) : (
                <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-form">
                    <p className="text-sm text-[#a0a0a0]">Enter your email and we'll send you a link to set a new password.</p>
                    <div>
                        <Label className="text-xs uppercase tracking-[0.2em] text-[#a0a0a0]">Email</Label>
                        <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 h-12 rounded-none bg-[#141414] border-[#2a2a2a]" />
                    </div>
                    <Button type="submit" data-testid="forgot-submit" disabled={busy} className="w-full h-12 rounded-none bg-[#ff4500] hover:bg-[#ff5722] uppercase tracking-[0.2em] text-xs font-semibold">{busy ? "Sending…" : "Send reset link"}</Button>
                    <Link to="/login" className="block text-center text-xs uppercase tracking-[0.2em] text-[#a0a0a0] hover:text-white">Back to log in</Link>
                </form>
            )}
        </div>
    );
}
